export const API_URL = process.env.NEXT_PUBLIC_API_URL
export const API_INTERNAL_URL = process.env.NEXT_PUBLIC_INTERNAL_API_URL
export const SITE_URL = process.env.NEXT_PUBLIC_DOMAIN_URL
export const MAX_TIME_TOKEN_VERIFICATION =
  +process.env.MAX_TIME_TOKEN_VERIFICATION! || 60
export const ENVIROMENT = process.env.NEXT_PUBLIC_ENVIROMENT || 'development'
